<template>
  <div class="section-title">
    <span class="section-title__bar" />
    <h3 class="section-title__text">{{ title }}</h3>
    <a v-if="moreLink" href="#" class="section-title__more" @click.prevent="$emit('more')">
      查看更多 &gt;
    </a>
  </div>
</template>

<script>
export default {
  name: 'SectionTitle',
  props: {
    title: { type: String, required: true },
    moreLink: { type: Boolean, default: false }
  }
}
</script>

<style lang="scss" scoped>
.section-title {
  display: flex;
  align-items: center;
  gap: $spacing-sm;
  margin-bottom: $spacing-base;

  &__bar {
    width: 4px;
    height: 20px;
    background: $color-brown-dark;
    border-radius: 2px;
    flex-shrink: 0;
  }

  &__text {
    font-family: $font-serif;
    font-size: rem(22);
    font-weight: 700;
    color: $color-brown-dark;
    letter-spacing: 2px;
    flex: 1;
  }

  &__more {
    font-size: rem(13);
    color: $color-text-light;

    &:hover {
      color: $success-color;
    }
  }
}
</style>
